import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_INPUT_MODE,
  SET_NUM_INPUT_SET,
  CLEAR_RESULT_SELECTED,
  CLEAR_RESULTS,
  SET_HISTORY,
  SET_TITLE_OBJ,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
} from './constants'

import { setStartRotate } from '../turntable/actions'
import { setDataStatus } from '../common/actions'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (result, resultPieColor = null) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultPieColor,
  },
})

export const clearResultSelected = () => ({
  type: CLEAR_RESULT_SELECTED,
})

export const clearResults = () => ({
  type: CLEAR_RESULTS,
})

export const setInputMode = inputMode => async (dispatch, getState) => {
  const state = getState()
  const startAngle = state.settings.spinBehavior.randomStart
    ? 2 * Math.PI * Math.random()
    : 0
  dispatch(setStartRotate(startAngle))
  dispatch(setInputModeAction(inputMode))
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setInputModeAction = inputMode => ({
  type: SET_INPUT_MODE,
  payload: {
    inputMode,
  },
})

export const setNumInputSet = numInputSet => async (dispatch, getState) => {
  const state = getState()
  const startAngle = state.settings.spinBehavior.randomStart
    ? 2 * Math.PI * Math.random()
    : 0
  dispatch(setStartRotate(startAngle))
  dispatch(setNumInputAction(numInputSet))
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setNumInputAction = numInputSet => ({
  type: SET_NUM_INPUT_SET,
  payload: {
    numInputSet,
  },
})

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

//03-07-2021 add title
export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.ynw.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
    } catch (error) {
      console.log(error)
    }
  }
